module.exports = __webpack_public_path__ + "static/img/index_vip.1e9cbad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event/Christmas2020/index_vip.png
// module id = 1XbQ
// module chunks = 1